import { SCORECARD_INITIAL_VALUES } from '../action';
const initialState = {}
const scorecardInitialValuesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCORECARD_INITIAL_VALUES:
            return {
                data: action.data,
            };
        default:
            return state;
    }
};

export default scorecardInitialValuesReducer